import { DATE_FORMAT } from 'constants/MenstrualCycleTrackingConstants';
import moment from 'moment';
import {
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL,
    RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
    ADD_OR_REMOVE_MENSTRUAL_DATE,
    SET_MCT_CALENDAR_MODAL_OPENED_STATE,
    SET_MCT_CALENDAR_SELECTED_DATES_TO_PRISTINE,
    SAVE_MENSTRUAL_DATE_CHANGES_FAIL,
    SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS,
    SAVE_MENSTRUAL_DATE_CHANGES_START,
    ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
    ENDED_CYCLE_UPDATE_FROM_CALENDAR,
    ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL,
    STARTED_CYCLE_UPDATE_FROM_CALENDAR,
    SET_MCT_CALENDAR_MODAL_OPENED_IN_EDIT_STATE,
    SET_CALENDAR_EDITABLE_UNTIL_DATE,
    RESET_CALENDAR_EDITABLE_UNTIL_DATE
} from 'actions/ActionTypes';
import { setOrUnsetCurrentPeriodEditingInFutureDates } from 'utils/MctUtil';
import { setMenstrualCycleAndFertileDates } from '../../utils/MctUtil';

const INITIAL_STATE = {
    menstrualCycleTrackingCalendar: {},
    dataForCheckingIfHasActiveCyclesSixMonthsObject: {},
    dataForCheckingIfHasActiveCyclesSixMonths: {
        loggedOvulationDays: [],
        loggedSymptomDays: [],
        fertileDates: [],
        menstrualDates: []
    },
    calendarEditableUntilAndIncludingDate: false,
    isMenstrualCycleTrackingCalendarModalOpened: false,
    isMenstrualCycleTrackingCalendarModalInEdit: false,
    menstrualCycleTrackingCalendarFetching: false,
    menstrualCycleTrackingFetchFail: false,
    menstrualCycleTrackingSaveRequesting: false,
    menstrualCycleTrackingSaveSuccess: true,
    calendarUpdateInProgress: false,
    closeModalOnSuccess: false,
    allCalendarEventDates: {
        loggedOvulationDays: [],
        loggedSymptomDays: [],
        fertileDates: [],
        menstrualDates: []
    },
    allPristineCalendarEventDates: {
        loggedOvulationDays: [],
        loggedSymptomDays: [],
        fertileDates: [],
        menstrualDates: []
    },
    currentCycleThatContinuesInTheFuture: [],
    removedDates: []
};

const startedCycleUpdateFromCalendar = (state) => {
    return {
        ...state,
        calendarUpdateInProgress: true
    };
};

const endedCycleUpdateFromCalendar = (state) => {
    return {
        ...state,
        calendarUpdateInProgress: false
    };
};

export const calendarUpdateInProgressState = (state) => {
    return state.menstrualCycleTrackingCalendar.calendarUpdateInProgress;
};

const menstrualCycleTrackingCalendarFetching = (state) => {
    return {
        ...state,
        menstrualCycleTrackingCalendarFetching: true,
        menstrualCycleTrackingFetchFail: false
    };
};

const menstrualCyclingTrackingCalendarFetchFinished = (isSuccess) => (state, action) => {
    let menstrualCycleTrackingCalendarDates = { ...state.menstrualCycleTrackingCalendar };
    let dataForCheckingIfHasActiveCycles = { ...state.dataForCheckingIfHasActiveCyclesSixMonthsObject };
    let tempMenstrualCycleTrackingCalendarDates = {};

    if (isSuccess && !action.isForDeleteAllDatesCheck) {
        menstrualCycleTrackingCalendarDates[action.startDate + '/' + action.endDate] =
            action.menstrualCycleTrackingCalendar;
        tempMenstrualCycleTrackingCalendarDates[action.startDate + '/' + action.endDate] =
            action.menstrualCycleTrackingCalendar;
    } else if (isSuccess && action.isForDeleteAllDatesCheck) {
        dataForCheckingIfHasActiveCycles[action.startDate + '/' + action.endDate] =
            action.menstrualCycleTrackingCalendar;
    }

    let dataForCheckingIfHasActiveCyclesSixMonthObject = setMenstrualCycleAndFertileDates(
        dataForCheckingIfHasActiveCycles
    );
    let setMenstrualCycleAndFertileDatesObject = setMenstrualCycleAndFertileDates(
        menstrualCycleTrackingCalendarDates,
        tempMenstrualCycleTrackingCalendarDates,
        state.allCalendarEventDates,
        state.removedDates
    );
    let setPristineMenstrualCycleAndFertileDatesObject = setMenstrualCycleAndFertileDates(
        menstrualCycleTrackingCalendarDates
    );

    return {
        ...state,
        menstrualCycleTrackingCalendar: { ...menstrualCycleTrackingCalendarDates },
        dataForCheckingIfHasActiveCyclesSixMonthsObject: { ...dataForCheckingIfHasActiveCycles },
        menstrualCycleTrackingCalendarFetching: false,
        menstrualCycleTrackingFetchFail: !isSuccess,
        dataForCheckingIfHasActiveCyclesSixMonths: { ...dataForCheckingIfHasActiveCyclesSixMonthObject },
        allCalendarEventDates: { ...setMenstrualCycleAndFertileDatesObject },
        allPristineCalendarEventDates: { ...setPristineMenstrualCycleAndFertileDatesObject }
    };
};

const setMenstrualCycleTrackingSaveRequesting = (state) => {
    return {
        ...state,
        menstrualCycleTrackingSaveRequesting: true,
        closeModalOnSuccess: false
    };
};

const setMenstrualCycleTrackingSaveState = (isSuccess) => (state, action) => {
    return {
        ...state,
        menstrualCycleTrackingSaveSuccess: isSuccess,
        menstrualCycleTrackingSaveRequesting: false,
        closeModalOnSuccess: isSuccess,
        removedDates: []
    };
};

const setAllCalendarSelectedEventDatesToPristine = (state) => {
    return {
        ...state,
        allCalendarEventDates: { ...state.allPristineCalendarEventDates }
    };
};

export const getMenstrualCycleTrackingSaveRequestingState = (state) => {
    return state.menstrualCycleTrackingCalendar.menstrualCycleTrackingSaveRequesting;
};

export const getMenstrualCycleTrackingCalendar = (state) => {
    return state.menstrualCycleTrackingCalendar.menstrualCycleTrackingCalendar;
};

export const getAllCalendarEvents = (state) => {
    return state.menstrualCycleTrackingCalendar.allCalendarEventDates;
};

export const getDataForCheckingIfHasActiveCyclesSixMonths = (state) => {
    return state.menstrualCycleTrackingCalendar.dataForCheckingIfHasActiveCyclesSixMonths;
};

export const getMenstrualCycleTrackingCalendarFetching = (state) =>
    state.menstrualCycleTrackingCalendar.menstrualCycleTrackingCalendarFetching;

export const getAllPristineCalendarEvents = (state) => {
    return state.menstrualCycleTrackingCalendar.allPristineCalendarEventDates;
};

export const getCalendarEditableUntilAndIncludingDate = (state) => {
    return state.menstrualCycleTrackingCalendar.calendarEditableUntilAndIncludingDate;
};

const setCalendarEditableUntilAndIncludingDate = (state, action) => {
    return {
        ...state,
        calendarEditableUntilAndIncludingDate: action.untilDate
    };
};

const resetCalendarEditableUntilAndIncludingDate = (state, action) => {
    return {
        ...state,
        calendarEditableUntilAndIncludingDate: INITIAL_STATE.calendarEditableUntilAndIncludingDate
    };
};

export const getMenstrualCycleTrackingCalendarModalOpenedState = (state) => {
    return state.menstrualCycleTrackingCalendar.isMenstrualCycleTrackingCalendarModalOpened;
};

export const getCloseModalOnSuccessState = (state) => {
    return state.menstrualCycleTrackingCalendar.closeModalOnSuccess;
};

export const getMenstrualCycleTrackingSaveState = (state) => {
    return state.menstrualCycleTrackingCalendar.menstrualCycleTrackingSaveSuccess;
};

const setCalendarModalOpenedState = (state, action) => {
    return {
        ...state,
        isMenstrualCycleTrackingCalendarModalOpened: action.isOpened
    };
};

const setCalendarModalOpenedInEditState = (state, action) => {
    const { menstrualDates } = state.allCalendarEventDates;
    let todayDate = moment().format(DATE_FORMAT);
    let isTodayInMenstrualDate = menstrualDates.indexOf(todayDate) !== -1;
    let currentCycleThatContinuesInTheFuture = setOrUnsetCurrentPeriodEditingInFutureDates(
        menstrualDates,
        todayDate,
        !isTodayInMenstrualDate
    );

    return {
        ...state,
        isMenstrualCycleTrackingCalendarModalInEdit: action.isOpenedAndInEdit,
        currentCycleThatContinuesInTheFuture: [...currentCycleThatContinuesInTheFuture]
    };
};

export const getMenstrualCycleTrackingInEditState = (state) => {
    return state.menstrualCycleTrackingCalendar.isMenstrualCycleTrackingCalendarModalInEdit;
};

export const getCurrentCycleThatContinuesInTheFuture = (state) => {
    return state.menstrualCycleTrackingCalendar.currentCycleThatContinuesInTheFuture;
};

const addOrRemoveMenstrualDate = (state, action) => {
    const { menstrualDates } = state.allCalendarEventDates;
    const day = action.date;
    let newRemovedDates = [...state.removedDates];
    const indexOfDateInMenstrualDatesArray = menstrualDates.indexOf(day);
    let newMenstrualDates = [...menstrualDates];
    let currentCycleThatContinuesInTheFuture = [];

    if (indexOfDateInMenstrualDatesArray === -1) {
        newMenstrualDates.push(day);
        currentCycleThatContinuesInTheFuture = setOrUnsetCurrentPeriodEditingInFutureDates(menstrualDates, day);
        newRemovedDates = newRemovedDates.filter((date) => date !== day);
    } else {
        newRemovedDates.push(newMenstrualDates.splice(indexOfDateInMenstrualDatesArray, 1)[0]);
        currentCycleThatContinuesInTheFuture = setOrUnsetCurrentPeriodEditingInFutureDates(menstrualDates, day, true);
    }

    return {
        ...state,
        allCalendarEventDates: {
            ...state.allCalendarEventDates,
            menstrualDates: [...newMenstrualDates]
        },
        removedDates: newRemovedDates,
        currentCycleThatContinuesInTheFuture: [...currentCycleThatContinuesInTheFuture]
    };
};

const resetMenstrualCycleTrackingCalendar = () => {
    return { ...INITIAL_STATE };
};

const onlyResetMenstrualCycleTrackingCalendar = (state) => {
    return {
        ...state,
        menstrualCycleTrackingCalendar: { ...INITIAL_STATE.menstrualCycleTrackingCalendar },
        allCalendarEventDates: { ...INITIAL_STATE.allCalendarEventDates }
    };
};

const handlers = {
    [FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING]: menstrualCycleTrackingCalendarFetching,
    [SAVE_MENSTRUAL_DATE_CHANGES_START]: setMenstrualCycleTrackingSaveRequesting,
    [FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS]: menstrualCyclingTrackingCalendarFetchFinished(true),
    [FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL]: menstrualCyclingTrackingCalendarFetchFinished(false),
    [SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS]: setMenstrualCycleTrackingSaveState(true),
    [SAVE_MENSTRUAL_DATE_CHANGES_FAIL]: setMenstrualCycleTrackingSaveState(false),
    [ADD_OR_REMOVE_MENSTRUAL_DATE]: addOrRemoveMenstrualDate,
    [RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR]: resetMenstrualCycleTrackingCalendar,
    [ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR]: onlyResetMenstrualCycleTrackingCalendar,
    [SET_MCT_CALENDAR_MODAL_OPENED_STATE]: setCalendarModalOpenedState,
    [SET_MCT_CALENDAR_MODAL_OPENED_IN_EDIT_STATE]: setCalendarModalOpenedInEditState,
    [STARTED_CYCLE_UPDATE_FROM_CALENDAR]: startedCycleUpdateFromCalendar,
    [ENDED_CYCLE_UPDATE_FROM_CALENDAR]: endedCycleUpdateFromCalendar,
    [ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL]: endedCycleUpdateFromCalendar,
    [SET_MCT_CALENDAR_SELECTED_DATES_TO_PRISTINE]: setAllCalendarSelectedEventDatesToPristine,
    [SET_CALENDAR_EDITABLE_UNTIL_DATE]: setCalendarEditableUntilAndIncludingDate,
    [RESET_CALENDAR_EDITABLE_UNTIL_DATE]: resetCalendarEditableUntilAndIncludingDate
};

export default function menstrualCycleTrackingCalendar(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
